<style lang="scss">
    .app-content {
        height: 100vh;
        max-width: 100vw;
        overflow-y:scroll;
        overflow-x:hidden;
        -webkit-overflow-scrolling:touch;
        padding-top: 50px; }

        .app-body {
            position:relative;
            min-height: 100vh;
            font-family: "Poppins", sans-serif;
            padding-bottom: 100px;
            // overflow-y: auto;
            .fixed-width {
                max-width: 1000px;
                margin:auto;

        }

            .back-button {
                padding: 20px 1.5rem 0;
                color: #595e63;
                position:relative;
                z-index: 10;

                div {
                    cursor:pointer;
                    width: 60px;

            }

        }
          &--full-width-forced {
              display: flex;
              min-height: 100%;
              padding-bottom: 60px; // Size of the playerbar height

              .fixed-width {
                  width: 100%;
                  margin: 0;
                  max-width: unset;
              }
          }
    }

        input, select, textarea, .form-control, .input-group {
            border-radius: 5px !important;
            background-color: var(--input-background-color);
            color: var(--input-text-color);
            border-color: var(--input-border-color);

    }

        option {
            color: var(--input-text-color);

    }

        .input-group:focus, .form-control:focus, input:focus, select:focus, textarea:focus {
            border-radius: 5px !important;
            background-color: var(--input-background-color);
            color: var(--input-text-color);
            border-color: var(--input-border-color);
            outline:none;
            box-shadow:inset 0 0 0 rgba(0, 0, 0, 0.075), 0 0 10px var(--input-border-color);

    }

        .form-control::placeholder, input::placeholder {
            color: var(--input-placeholder-color);

    }

        .input-group {

            .btn {
                border-color: var(--input-border-color);

        }

            &:focus {

                .btn {
                    box-shadow:inset 0 0 0 rgba(0, 0, 0, 0.075), 0 0 10px var(--input-border-color);

            }

        }

    }

        .btn {
            border-radius: 5px;
            color: #ffffff;
            font-family:Poppins;
            font-size: 14px;
            font-weight: 500;

    }

        .btn-default {
            background-color: #a7a7a7 !important;

    }

        .btn-default:hover {
            color: #ffffff !important;

    }

        .btn-danger {
            background-color: #ff1466 !important;

    }

        .btn-success {
            background-color: #00d38a !important;

    }

        .btn-shadow {
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

    }
        @media (min-width: 768px) and (max-width: 1300px)
    {

        .app-content.with-mega-menu {
            padding-top: 96px;

    } }

        .loading-overlay {
            display:block;
            z-index: 9000;
            position:absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(255, 255, 255, 0.73);
            transition:opacity 500ms;
            visibility:visible;
            opacity: 1;
            background-image: url("https://i.imgur.com/YB4fJJk.gif");
            background-size: 100px 100px;
            background-position: 50% 25%;
            background-repeat:no-repeat;

    }

        .remove-overflow {
            overflow-y:hidden;

    }

        .store-outer-wrapper {

            &.no-tour {

                .tour-backdrop {
                    display:none;

            }

        }

    }

        @media screen and (min-width: 1000px)
    {

        .item-title, .tile-item-title,
        .price-wrapper,
        .breadcrumbs, .checkout-item, .checkout-page,
        .cart-total, .contact {

            a:hover {
                text-decoration: underline !important;

        }

    }

        .share-button:hover {
            text-decoration: underline !important;

    } }

        .config-overlay {
            position:absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1000;
            cursor:pointer;

    }
</style>
<template>
    <div class="store-outer-wrapper" ref="storeOuterWrapper" :class="{'no-tour': !this.$store.state.showTour}"
         :style="style">
        <tour v-if="$configure && !impersonating"></tour>

        <div class="store-wrapper">
            <top-menu></top-menu>
            <div id="content" class="app-content" role="main" :style="$mainBodyStyle" @click="closeMenu()">
                <!--<scroll-bars class="app-body" :options="bodyScrollOptions">-->
                <!--<template slot="scroll-content">-->
                <!--<router-view></router-view>-->
                <!--</template>-->
                <!--</scroll-bars>-->

                <div :class="{'loading-overlay': loadingOverlay}"></div>
                <div id="app_body" class="app-body main-background main-primary-text" :class="{'app-body--full-width-forced': pageFullWidthForced}">
                    <div class="config-overlay" v-show="$store.state.dismissConfigOverlay"
                         @click="dismissConfigPanel"></div>
                    <search-bar v-show="!isOrderHistoryPage" :display="search"></search-bar>
                    <div :class="{'fixed-width': !pageFullWidth}">
                        <breadcrumbs v-if="!isOrderHistoryPage"></breadcrumbs>
                        <router-view :currentPage="currentPage"></router-view>
                    </div>
                </div>
            </div>
            <play-bar v-if="showPlayer"></play-bar>
        </div>

        <configuration-panel v-if="$configure" v-cloak></configuration-panel>

        <cart-modal></cart-modal>
        <buy-license-modal :beat="buyableBeat"></buy-license-modal>
        <offer-modal :offerable="offerable"></offer-modal>
        <login-modal v-if="!loggedInUser"></login-modal>
        <orders-modal v-if="loggedInUser"></orders-modal>
        <discounts-modal v-if="user.discountsAvailable"></discounts-modal>
        <share-modal :shareable="shareable" :shareFromPage="shareFromPage"></share-modal>
        <download-modal :downloadable="downloadable"></download-modal>
        <beat-tape-modal></beat-tape-modal>
        <checkout-customer-email-confirm-modal></checkout-customer-email-confirm-modal>
        <the-soundkit-pricing-modal />
        <buyer-instructions-modal />
        <the-soundkit-terms-modal />
        <youtube-video-modal />
        <service-inquiry-modal />
        <subscription-modal></subscription-modal>
        <licenseTerms></licenseTerms>
        <licenseAgreements v-if="cartItems.length > 0"></licenseAgreements>
        <share-cart></share-cart>
        <facebook-live-chat></facebook-live-chat>
        <tidio-live-chat></tidio-live-chat>
    </div>
</template>


<script>


import Beat from './models/beat'
import Song from './models/song'
import SoundKit from './models/soundkit'
import Collection from './models/collection'
import Cart from './classes/Cart'
import CartItem from './classes/CartItem'
import Store from './store/store'
import Configure from './mixins/configure'
import Configuration from './models/configuration'
import MobileDetect from "mobile-detect"
import TidioLiveChat from './components/live-chat/tidio/tidio-chat-widget.vue'
import FacebookLiveChat from './components/live-chat/facebook/facebook-chat-widget.vue'
import PlayBar from './components/player.vue'
import TopMenu from './components/topmenu.vue'
import SearchBar from './components/searchbar.vue'
import BeatTapeModal from './components/modals/beat-tape.vue'
import CartModal from './components/modals/cart.vue'
import BuyLicenseModal from './components/modals/buylicense.vue'
import OfferModal from './components/modals/offer.vue'
import LoginModal from './components/modals/login.vue'
import OrdersModal from './components/modals/orders.vue'
import DiscountsModal from './components/modals/discounts.vue'
import ShareModal from './components/modals/share.vue'
import DownloadModal from './components/modals/download.vue'
import ShareCart from './components/modals/sharecart.vue'
import licenseTerms from './components/modals/license-terms.vue'
import licenseAgreements from './components/modals/license-agreements.vue'
import Breadcrumbs from './components/breadcrumbs.vue'
import Tour from './components/tour.vue'
import Styles from './mixins/styles.vue'
import CheckoutCustomerEmailConfirmModal from './components/checkout/checkout-customer-email-confirm-modal.vue'
import {ConfigurationPanel} from './chunks'
import TheSoundkitPricingModal from "./components/soundkits/TheSoundkitPricingModal";
import TheSoundkitTermsModal from "./components/soundkits/TheSoundkitTermsModal";
import YoutubeVideoModal from "./components/modals/youtube-video-modal";
import SubscriptionModal from "./components/email-subscription/EmailSubscriptionModal.vue"
import IdentityTracker from "../../shared/mixins/identityTracker"
import Service from "./models/service"
import ServiceQuote from "./models/ServiceQuote"
import BuyerInstructionsModal from "./components/modals/buyer-instructions-modal";
import ServiceInquiryModal from "./components/modals/service-inquiry";

export default {
        components: {
            ServiceInquiryModal,
            BuyerInstructionsModal,
            SubscriptionModal,
            YoutubeVideoModal,
            TheSoundkitTermsModal,
            TheSoundkitPricingModal,
            TidioLiveChat,
            FacebookLiveChat,
            PlayBar,
            ConfigurationPanel,
            TopMenu,
            SearchBar,
            CartModal,
            BuyLicenseModal,
            OfferModal,
            LoginModal,
            OrdersModal,
            DiscountsModal,
            ShareModal,
            DownloadModal,
            ShareCart,
            licenseTerms,
            licenseAgreements,
            Breadcrumbs,
            Tour,
            CheckoutCustomerEmailConfirmModal,
            BeatTapeModal
        },
        beforeCreate() {
            if (ab.uid && this.$store.state.bugsnagClient) {
                this.$store.state.bugsnagClient.user.id = ab.uid;
            }
            // Get the base URL based on the current domain name
            ab.baseUrl = Store.state.domainUrlBuilder.build();
        },
        created() {
            this.$store.commit("app", {app: this})
            this.checkIfMobile()
            let config = new Configuration(ab.config)
            this.$store.commit("originalConfig", {config: config})
            this.$store.commit("currentConfig", {config: config})

            this.initCart()
            this.setSavedCart()
            this.setUpEventListeners()
//            this.addPauseEventListener();
        },
        mounted() {
            // This event listener is to prevent an issue on iphone with capturing touchstart event on iframe
            this.$nextTick(() => {
                this.$refs.storeOuterWrapper.addEventListener("touchstart", function () {
                });
            });
        },
        data() {
            return {
                bodyScrollOptions: {
                    theme: "minimal",
                    autoExpandScrollbar: true,
                    callbacks: {
                        whileScrolling() {
                            if (this.mcs.topPct > 60 && !Store.state.playlistLoadingComplete && !Store.state.loadMoreInPlaylist) {
                                Store.commit("loadMoreInPlaylist", {load: true})
                            }
                        },
                    }
                }
            }
        },
        computed: {
            isOrderHistoryPage(){
                return this.$route.name === 'order-history' || this.$route.name === 'order-details'
            },
            user() {
                return this.$store.state.user
            },
            config() {
                return this.$store.state.currentConfig
            },
            editingConfig() {
                return this.$store.state.editingConfig
            },
            buyableBeat() {
                return this.$store.state.buyableBeat
            },
            offerable() {
                return this.$store.state.offerable
            },
            shareable() {
                return this.$store.state.shareable
            },
            shareFromPage(){
                return this.$store.state.shareFromPage
            },
            downloadable() {
                return this.$store.state.downloadable
            },
            loggedInUser() {
                return this.$store.state.loggedInUser
            },
            search() {

                if (this.$route.name == "checkout") {
                    return false
                }

                if(this.$route.name == "beat-tapes" || this.$route.name == "beat-tape" || this.$route.name === "service"){
                    return false;
                }

                if (this.$route.name == "beat" || this.$route.name == "song" || this.$route.name == "soundkit" || this.$route.name == "search") {
                    return "search"
                }

                if (this.currentPage && this.currentPage.hero) {
                    return "hero"
                }

                if (this.currentPage && this.currentPage.search) {
                    return "search"
                }

                return false
            },
            currentPage() {
                return this.$store.state.currentPage
            },
            loadingOverlay() {
                return this.$store.state.loadingOverlay
            },
            cartItems() {
                if (this.$store.state.cart) {
                    return this.$store.state.cart.getCart()
                }
                return []
            },
            pageFullWidth() {
                if (this.currentPage) {
                    return this.currentPage.page_full_width
                }
            },
            pageFullWidthForced() {
                return this.$store.state.pageFullWidthForced;
            },
            showPlayer() {
                return this.$store.state.player.playing || !['service', 'services'].includes(this.currentPage?.type);
            },
            minimiseMenu() {
                return this.config.stylesConfig.menu.minimise_menu.value
            },
            impersonating() {
                if (this.$configure && this.user.id != this.loggedInUser.id) {
                    return true
                }
                return false
            },
        },
        mixins: [Configure, Styles, IdentityTracker],
        methods: {
            checkIfMobile() {
                let mobile = new MobileDetect(window.navigator.userAgent).mobile();
                if (mobile) {
                    this.$store.commit("mobile");
                }
            },
            initCart() {
                this.$store.commit("cart", {cart: new Cart()});
            },
            setUpEventListeners() {
                let vm = this

                $(window).resize(_.debounce(function () {
                    vm.$store.commit("viewPortWidth", {width: window.innerWidth})
                }, 200))

                $("body").keyup(function (e) {
                    if (e.key == "Escape" || e.key == "Esc") {
                        $(".modal").modal("hide")
                    }
                })

            },
            setSavedCart() {
                if (!_.isEmpty(ab.cart) && ab.cart.items.length > 0) {
                    let cartItems = this.getSavedCartItems(ab.cart.items)

                    this.$store.state.cart.processSavedCart(cartItems)
                }

                this.setSavedCoupon()
            },
            getSavedCartItems(items) {
                let cartItems = []

                for (let i = 0; i < items.length; i++) {
                    let item = items[i]

                    if (item.cartable != null && item.cartable.polymorphicType != undefined) {
                        switch (item.cartable.polymorphicType) {
                            case 'beat':
                                let beat = new Beat(item.cartable)
                                cartItems.push(new CartItem(beat, beat.pricing[item.license.id].license, beat.pricing[item.license.id].price, 'beat'))
                                break;
                            case 'song':
                                let song = new Song(item.cartable)
                                cartItems.push(new CartItem(song, null, song.price, 'song'))
                                break;
                            case 'soundkit':
                                let kit = new SoundKit(item.cartable)
                                cartItems.push(new CartItem(kit, item.license, item.license.price, 'soundkit'))
                                break;
                            case 'collection':
                                let collection = Collection.make(item.cartable)
                                cartItems.push(new CartItem(collection, null, collection.price, 'collection'))
                                break;
                            case 'service':
                                let service = new Service(item.cartable)
                                cartItems.push(new CartItem(service, service.license, service.price, 'service'))
                                break
                            case 'service_quote':
                                let serviceQuote = new ServiceQuote(item.cartable)
                                cartItems.push(new CartItem(serviceQuote, serviceQuote.license, serviceQuote.price, 'service_quote'))
                                break
                        }
                    }
                }

                return cartItems
            },
            setSavedCoupon() {
                const coupon = ab.cart.coupon
                if (coupon) {
                    this.$store.state.cart.applyCoupon(coupon)

                    let message = `A ${coupon.discount}% discount has been applied to `;
                    message += coupon.applies_to.map(type => (type+"s").toUpperCase()).join(", ");

                    if(coupon.licenses.length){
                        message += " and the following licenses: ";
                        let licenseNames = []
                        for (let i in coupon.licenses) {
                            let license = coupon.licenses[i];
                            licenseNames.push(license.name);
                        }
                        message += licenseNames.join(", ");
                    }

                    if (coupon.maxItems) {
                        message += ". MAX " + coupon.maxItems + `${coupon.maxItems > 1 ? " ITEMS" : " ITEM"}.`
                    }

                    this.$store.commit("coupon", {
                        discountString: message,
                        code: ab.cart.coupon.code
                    })
                }
            },
            back() {
                this.$router.go(-1)
            },
            closeMenu() {
                if (window.innerWidth < 768 && this.$store.state.collapseMenu) {
                    $(this.$store.state.collapseMenu).collapse("hide")
                }
            },
            dismissConfigPanel() {
                if (this.$store.state.dismissConfigOverlay != false) {
                    this.$store.commit('dismissConfigOverlay')
                }
            },
        },
        watch: {
            '$store.state.loadingOverlay': {
                handler(val) {
                    if (val) {
                        $('body').addClass('remove-overflow')
                    } else {
                        $('body').removeClass('remove-overflow')
                    }
                },
                immediate: true
            }
        }
    }
</script>
